document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('img').forEach(function (image) {
    function hideBrokenImage() {
      image.hidden = true;
      image.closest('[data-slide-media]')?.classList.add('has-missing-image');
    }

    if (image.complete && image.naturalWidth === 0) {
      hideBrokenImage();
    } else {
      image.addEventListener('error', hideBrokenImage, { once: true });
    }
  });

  if (window.Swiper) {
    document.querySelectorAll('[data-custom-swiper]').forEach(function (element) {
      new window.Swiper(element, {
        loop: false,
        watchOverflow: true,
        spaceBetween: 12,
        slidesPerView: Number(element.dataset.slidesMobile || 1),
        navigation: {
          nextEl: element.querySelector('.swiper-button-next'),
          prevEl: element.querySelector('.swiper-button-prev')
        },
        breakpoints: {
          768: {
            slidesPerView: Number(element.dataset.slidesTablet || 3),
            spaceBetween: 14
          },
          1024: {
            slidesPerView: Number(element.dataset.slidesDesktop || 5),
            spaceBetween: 16
          }
        }
      });
    });
  }

  document.querySelectorAll('[data-diamond-shapes]').forEach(function (section) {
    var preview = section.querySelector('[data-diamond-preview]');
    var previewLink = section.querySelector('[data-diamond-preview-link]');
    var items = section.querySelectorAll('[data-diamond-shape]');
    var changeTimer = null;

    function activate(item) {
      var nextSrc = item.dataset.previewSrc;
      var nextAlt = item.dataset.previewAlt || '';

      items.forEach(function (shape) {
        shape.classList.toggle('active', shape === item);
      });

      if (previewLink && item.href) {
        previewLink.href = item.href;
      }

      if (!preview || !nextSrc || preview.getAttribute('src') === nextSrc) return;

      window.clearTimeout(changeTimer);
      preview.classList.add('is-changing');
      changeTimer = window.setTimeout(function () {
        preview.src = nextSrc;
        preview.alt = nextAlt;
        preview.classList.remove('is-changing');
      }, 110);
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        activate(item);
      });
      item.addEventListener('focus', function () {
        activate(item);
      });
      item.addEventListener('touchstart', function () {
        activate(item);
      }, { passive: true });
    });
  });
});
